import React, { Component } from 'react';
import Select from 'react-select';

import { getBtnClass, formatLink } from '@triage-help/helpers';

class AutoRetune extends Component {
  constructor(props) {
    super(props);

    let selectedBrand = this.findBrand(props.selectedBrand);

    this.state = {
      selectedBrand: selectedBrand,
      isBrandDisplayed: false,
    };

    this.brandOptions = [];
    props.step.tv_brands.forEach(brand => {
      this.brandOptions.push({
        value: brand.name,
        label: brand.name,
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isBrandDisplayed !== prevState.isBrandDisplayed) {
      $(window).scrollTop(0);
    }

    // Fixes a bug where if two of the same component were one after the other,
    // the second page of content would be shown.
    if (prevProps.step.id !== this.props.step.id) {
      this.setState({
        selectedBrand:
          this.props.selectedBrand !== undefined
            ? this.findBrand(this.props.selectedBrand)
            : null,
        isBrandDisplayed: false,
      });
    }
  }

  findBrand(selection) {
    return this.props.step.tv_brands.find(b => {
      return b.name === selection;
    });
  }

  handleSelect(selection) {
    const selectedBrand = this.findBrand(selection.value);

    this.setState({
      selectedBrand: selectedBrand,
    });

    // Pass this back to the app to control.
    if (selectedBrand.name !== this.props.selectedBrand) {
      this.props.handleUpdatedBrand(selectedBrand.name);
    }
  }

  handleNext() {
    if (this.state.selectedBrand) {
      this.setState({
        isBrandDisplayed: true,
      });
    }
  }

  render() {
    const { step, goToStep, goToPrev } = this.props;
    const prevLink = step.link.find(l => l.type == 'prev');

    let defaultSelection = null;
    if (this.state.selectedBrand !== undefined) {
      defaultSelection = {
        value: this.state.selectedBrand.name,
        label: this.state.selectedBrand.name,
      };
    }

    return (
      <div
        className={`fv-triage-card ${
          this.state.isBrandDisplayed ? 'fv-triage-card--centered' : ''
        }`}
      >
        {!this.state.isBrandDisplayed && (
          <div className="row">
            <div className="col-sm-12 col-md-7 fv-triage-card__content">
              <div dangerouslySetInnerHTML={{ __html: step.content }} />
            </div>
            <div className="col-sm-12 col-md-5 fv-triage-card__side fv-triage-card__channels">
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                defaultValue={defaultSelection}
                options={this.brandOptions}
                onChange={this.handleSelect.bind(this)}
              />
            </div>

            <div className="col-md-12 fv-triage-card__links">
              {prevLink && (
                <button
                  className={getBtnClass(prevLink.type)}
                  onClick={() => goToPrev()}
                >
                  {prevLink.text}
                </button>
              )}
              <div className="fv-triage-card__links__next">
                <button
                  className={getBtnClass('next', !!this.state.selectedBrand)}
                  onClick={() => this.handleNext()}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.isBrandDisplayed && (
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <h2>{this.state.selectedBrand.content_title}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.state.selectedBrand.content.replace(
                    '@detailed_transmitter_info',
                    formatLink(
                      '/corporate/detailed-transmitter-information',
                      location,
                    ),
                  ),
                }}
              />
            </div>
            <div className="col-md-12">
              <div className="fv-triage-card__links">
                {prevLink && (
                  <button
                    className={getBtnClass('prev')}
                    onClick={() =>
                      this.setState({
                        isBrandDisplayed: false,
                      })
                    }
                  >
                    Previous step
                  </button>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="fv-triage-card__separator-line" />
              {step.links_title && <h4>{step.links_title}</h4>}
              <div className="fv-triage-card__links">
                {step.link
                  .filter(l => l.type != 'prev')
                  .map((link, i) => {
                    return (
                      <button
                        className={getBtnClass(link.type)}
                        key={i}
                        onClick={() => goToStep(link.target)}
                      >
                        {link.text}
                      </button>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AutoRetune;
